import { AtomicElementViewForClipboard } from "notes-and-forms-v2/components/template-content/atomic-element-view/AtomicElementView";
import { SectionViewForClipboard } from "notes-and-forms-v2/components/template-content/section-view/SectionView";
import copyHtmlAsRichText from "utils/clipboard/copyHtmlAsRichText";
import jsxElementToHtml from "utils/clipboard/jsxElementToHtml";

export default function copyElementToClipboard(
  element: TemplateElement,
  data: any,
) {
  copyHtmlAsRichText(
    jsxElementToHtml(
      element.type === "section" ? (
        <SectionViewForClipboard element={element} data={data} />
      ) : (
        <AtomicElementViewForClipboard element={element} data={data} />
      ),
    ),
  );
}
